import PropTypes from 'prop-types'
import React from 'react'

import {css} from 'glamor'

const style = {
  container: css({
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%'
    }
  })
}

const Video = ({id, showTitle, showRelated}) => (
  <div {...style.container}>
    <iframe
      width="560"
      height="315"
      src={`https://www.youtube-nocookie.com/embed/${id}?rel=${+showRelated}&amp;showinfo=${+showTitle}`}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
    />
  </div>
)

Video.propTypes = {
  id: PropTypes.string.isRequired,
  showRelated: PropTypes.bool,
  showTitle: PropTypes.bool
}

Video.defaultProps = {
  showRelated: false,
  showTitle: false
}

export default Video
